<div class="card">
    <div class="card-header">
        <h4>TDR AND SURCHARGE SETTING</h4>
    </div>
    <div class="card-body m-0">
        <div class="row g-9 mb-8" [formGroup]="tdrForm">
            <div class="row mt-4">
                <div class="col-md-4">
                    <label class="col-form-label" for="merchant">
                        <span class="">Merchant</span>
                    </label>
                    <ng-select id="merchant" placeholder="Select Merchant" [inputAttrs]="{maxlength: '100'}"
                        formControlName="merchantEmailId" (ngModelChange)="getMappedAcquirer($event)">
                        <ng-option *ngFor="let item of merchants" value="{{item.emailId}}">
                            {{item.businessName}}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <label class="col-form-label" for="acquirer">
                        <span class="">Acquirer</span>
                    </label>
                    <ng-select id="acquirer" placeholder="Select Acquirer" [inputAttrs]="{maxlength: '100'}"
                        formControlName="acquirer">
                        <ng-option *ngFor="let item of acquirers" [value]="item">
                            {{ item }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-4">
                    <label class="col-form-label">
                        <span class="">Select Region</span>
                    </label>
                    <ng-select id="paymentType" placeholder="Select Region" [inputAttrs]="{maxlength: '100'}"
                        formControlName="paymentRegion">
                        <ng-option value="INTERNATIONAL">International</ng-option>
                        <ng-option value="DOMESTIC">Domestic</ng-option>
                    </ng-select>
                </div>
                <!-- <div class="col-md-4">
                    <label class="col-form-label" for="currency">
                        <span class="">Currency</span>
                    </label>
                    <ng-select id="currency" placeholder="Select Currency" [inputAttrs]="{maxlength: '100'}"
                        formControlName="currencyCode">
                        <ng-option *ngFor="let cur of currencyList" [value]="cur.code">
                            {{ cur.name }}
                        </ng-option>
                    </ng-select>
                </div> -->
            </div>
            <div class="row mt-4">
                <div class="col-md-4">
                    <label class="col-form-label">
                        <span class="">Select Type</span>
                    </label>
                    <ng-select id="paymentType" placeholder="Select Type" [inputAttrs]="{maxlength: '100'}"
                        formControlName="cardHolderType">
                        <ng-option value="CONSUMER">Consumer</ng-option>
                        <ng-option value="COMMERCIAL">Commercial</ng-option>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mt-4">
    <div class="card-body m-0">
        <div *ngFor="let table of tdrList" class="mb-4">
            <h3 class="bg-primary text-white p-2 rounded">{{ table.name }}</h3>
            <div class="row mt-3" style="min-height: 360px">
                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                    <ag-grid-angular [enableCellTextSelection]=true [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef" [tooltipShowDelay]="0" [enableCellTextSelection]=true
                        [rowData]="table[table.name]" [rowModelType]="" [rowSelection]="'single'"
                        [gridOptions]="gridOptions" style="width: 100%; height: auto;" [gridOptions]="gridOptions">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>